module.exports = girder_plugin_large_image_annotation;


//////////////////
// WEBPACK FOOTER
// external "girder_plugin_large_image_annotation"
// module id = 6
// module chunks = 0